import React from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
import { Box } from '@mui/material';

import { ProductionGroupSelection } from '@paragon/production-app-utilities';

import { selectProductionGroup } from '../../../actions/selectProductionGroup';
import { getProjectsWithActiveProductionGroups } from '../../../selectors/getProjectsWithActiveProductionGroups';
import { getProductionGroupsByProjectGuid } from '../../../selectors/productionGroups';
import { setActiveProjectGuid } from '../../../store/batchesAndBundlesTabSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ProjectSelection } from '../ProjectSelection';

export function ComponentsToBatchOrBundleGridToolbarPlugin() {
  const dispatch = useAppDispatch();
  const projects = useAppSelector(getProjectsWithActiveProductionGroups);
  const productionGroupsByProjectGuid = useAppSelector(getProductionGroupsByProjectGuid);
  const activeProjectGuid = useAppSelector((state) => state.batchesAndBundlesTab.activeProjectGuid);
  const activeProductionGroupGuid = useAppSelector((state) => state.batchesAndBundlesTab.activeProductionGroupGuid);

  return (
    <Plugin name="ComponentsToBatchOrBundleGridToolbar" dependencies={[{ name: 'Toolbar' }]}>
      <Template name="toolbarContent">
        <Box sx={{ display: 'flex', flexDirection: 'row', verticalAlign: 'middle' }}>
          <Box sx={{ p: 1, width: '500px' }}>
            <ProjectSelection
              activeProjectGuid={activeProjectGuid}
              projects={projects}
              setActiveProjectGuid={(guid) => void dispatch(setActiveProjectGuid(guid))}
            />
          </Box>
          <Box sx={{ p: 1, width: '500px' }}>
            <ProductionGroupSelection
              activeProductionGroupGuid={activeProductionGroupGuid}
              productionGroups={activeProjectGuid ? productionGroupsByProjectGuid[activeProjectGuid] : []}
              setActiveProductionGroupGuid={(guid) => void dispatch(selectProductionGroup(guid))}
              includeProjectDataInNames={false}
              disabled={activeProjectGuid === null}
            />
          </Box>
        </Box>
        <TemplatePlaceholder />
      </Template>
    </Plugin>
  );
}
